module.exports = __webpack_public_path__ + "static/media/features-bg-01.0eecdf11.png";